module.exports = __webpack_public_path__ + "img/share-scrips.c05b83f7.svg";